// extracted by mini-css-extract-plugin
export default {"message":"Core_message__H+b3+","messageContent":"Core_messageContent__tLqvR","messageHeader":"Core_messageHeader__Rrg1b"};